(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meeq-hero-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('[data-meeq-hero]').forEach(function(hero){
      if(hero.dataset.meeqReady) return; hero.dataset.meeqReady='1';
      var slides=Array.prototype.slice.call(hero.querySelectorAll('.meeq-hero__slide'));
      if(slides.length<2) return;
      var dotsWrap=hero.querySelector('.meeq-hero__dots');
      var autoplay=hero.dataset.autoplay==='true';
      var speed=(parseInt(hero.dataset.speed,10)||5)*1000;
      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var idx=0,timer;
      if(dotsWrap){
        dotsWrap.innerHTML=slides.map(function(_,i){return '<button type="button" aria-label="Slide '+(i+1)+'"'+(i===0?' class="on"':'')+'></button>';}).join('');
      }
      var dots=dotsWrap?Array.prototype.slice.call(dotsWrap.children):[];
      function show(n){
        slides[idx].classList.remove('is-active'); if(dots[idx])dots[idx].classList.remove('on');
        idx=(n+slides.length)%slides.length;
        slides[idx].classList.add('is-active'); if(dots[idx])dots[idx].classList.add('on');
      }
      function start(){ if(!autoplay||reduce)return; stop(); timer=setInterval(function(){show(idx+1);},speed); }
      function stop(){ clearInterval(timer); }
      dots.forEach(function(d,i){ d.addEventListener('click',function(){show(i);start();}); });
      var prev=hero.querySelector('.meeq-hero__arrow.prev'), next=hero.querySelector('.meeq-hero__arrow.next');
      if(prev)prev.addEventListener('click',function(){show(idx-1);start();});
      if(next)next.addEventListener('click',function(){show(idx+1);start();});
      hero.addEventListener('mouseenter',stop); hero.addEventListener('mouseleave',start);
      hero.addEventListener('focusin',stop);   hero.addEventListener('focusout',start);
      start();
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  // Re-init when added/edited in the theme editor
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
